import { defaultEnvironment } from "./environment.default";

export const environment = {
  ...defaultEnvironment,
  cdnUrl: "https://dj1ad7ph3z82s.cloudfront.net",
  debugInfoEnabled: false,
  faviconName: "favicon-blue",
  themeColor: "#0882b7",
  safariIconColor: "#0882b7",
  requireBaseTag: true,
  envName: "staging",
};
